'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Most of the code is lifted from Angular.js ngIf.
_module3.default.directive('languageRefresh', ['$animate', '$timeout', '$compile', function ($animate, $timeout, $compile) {
    return {
        transclude: 'element',
        priority: 500,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function link($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function show() {
                if (!childScope) {
                    $transclude(function (clone, newScope) {
                        childScope = newScope;
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper
                        // as it might be changed later by a directive with templateUrl
                        // when its template arrives.
                        block = {
                            clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                    });
                }
            }
            function hide() {
                if (previousElements) {
                    previousElements.remove();
                    previousElements = null;
                }
                if (childScope) {
                    childScope.$destroy();
                    childScope = null;
                }
                if (block) {
                    previousElements = block.clone;
                    $animate.leave(previousElements).then(function () {
                        previousElements = null;
                    });
                    block = null;
                }
            }
            show();
            $scope.$on('$localeChangeSuccess', function () {
                hide();
                show();
            });
        }
    };
}]); // Recreates a DOM element when language changes. Useful for components that 
// use one-time bindings for localized strings, assuming that the language won't
// change.


//////////////////
// WEBPACK FOOTER
// ./src/core/languageRefresh.js
// module id = 54
// module chunks = 0 2